import React, { useEffect, useState } from 'react';
import AlertCountChart from './BarGraph';
import AlertTrendsChart from './LineGraph';
import UserAlertLoadChart from './VerticalBarGraph'
import styled from 'styled-components';
import { AddIcon, AddIconWhite } from '../../Common/SvgIcon/CommonSvgIcons';
import AlertsTable from './AlertDetailTable';
import AlertConfigure from './AlertConfigure';
import PopUp from '../../Common/PopUp/PopUp';
import { transformJobDataToGroupedObject } from '../HomePage/HomeCustomHook';
import { useDispatch, useSelector } from 'react-redux';
import { activeTopicList } from '../../store/redux/slices/topicSlice';
import { chatterList } from '../../store/redux/slices/chatterSlice';
import { teamMemberList } from '../../store/redux/slices/tenantSettingSlice';
import { getAllAlert, getConfiguredAlerts, setEditEmpty } from '../../store/redux/slices/alertSlice';
import { getJobsListSlice } from '../../store/redux/slices/enterpriseSlice';

const FlexContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-top:35px;
    margin-bottom:30px;
`;
const GridContainer = styled.div`
    margin-top:10px;
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;

    & > div{
    border : 1px solid rgba(99, 99, 99, 1);
    }
`;
const MainWrapper = styled.div`
    min-width:1000px;
    width:96%;
    margin-left:20px;
    margin-right:auto;
    position:${(props) =>props?.showPopup == true ? 'fixed' : ''}

`;
const AddTenantBtn = styled.div`
  font-family: inherit;
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 18px;
    color:white;
    background:${(props) => props?.is_custom ? props?.is_custom : 'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'};
    width: 190px;
    height: 45px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    cursor:pointer;
`;
const AlertConfigFont = styled.div`
 & > .title {
  font-family: inherit;
    font-weight: 700;
    font-style: Bold;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-transform: capitalize;
    color: ${(props)=>props?.heading ? props?.heading : 'rgba(45, 137, 85, 1)'};
    width: 270px;
    height: 25px;
    text-align: justify;
 }

 & > .desc {
     color: rgba(99, 99, 99, 1);
  font-family: inherit;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: -1%;
    text-align: justify;
 }

`;


const AlertHomePage = () => {
    const [showAddAlert, setShowAddAlert] = useState(false);
    const [selectedTabs, setSelectedTabs] = useState([
        { title: 'Topic', isChecked: true, disable: false },
        { title: 'Chatter', isChecked: false, disable: true },
        { title: 'News & Blogs', isChecked: false, disable: true },
        { title: 'Enterprise', isChecked: false, disable: true },
    ]);
    const [channelData, setChannelData] = useState({
        topic: [
            { title: 'X', isChecked: true, disable: false },
            { title: 'Instagram', isChecked: false, disable: false },
            // { title: 'Facebook', isChecked: false, disable: true },
            // { title: 'YouTube', isChecked: false, disable: true },
        ],
        chatter: [
            { title: 'flipkart', isChecked: false, disable: true },
        ],
        news: [
            { title: 'news', isChecked: false, disable: true },
        ],
        Enterprise: [
            { title: 'Enterprise', isChecked: false, disable: true },
        ],
    });

  const { personalDetailsData } = useSelector((state) => state.tenantSetting);
    const [jobList, setJobList] = useState([]);
    const { alertsList } = useSelector((state) => state.alert) || [];
    const { chatterListDate } =
        useSelector((state) => state.chatterTracker) || [];
    const { activeTopicListData } =
        useSelector((state) => state.topicBuilder) || [];
    const [dataVal, setDataVal] = useState({});
    const dispatch = useDispatch()

    const getJobData = async () => {
        setJobList(null);
        const data = await dispatch(getJobsListSlice());
        // console.log(data?.payload);
        setJobList(data?.payload);
    };
    useEffect(() => {
        if (!activeTopicListData || !chatterListDate) {

            dispatch(activeTopicList())
            dispatch(chatterList())
        }

        dispatch(teamMemberList())
        dispatch(getAllAlert())
        getJobData();
        
        dispatch(getConfiguredAlerts())
    }, [])

    useEffect(() => {
        

        if (activeTopicListData || chatterListDate || jobList) {
            // normal grouping
            const combined = [...(activeTopicListData || []), ...(chatterListDate || [])];
            let groupedData = transformJobDataToGroupedObject(combined,false,false);

            // enterprise grouping
            if (jobList && jobList.length > 0) {
                const enterpriseGrouped = transformJobDataToGroupedObject(jobList, true,false);

                // merge Enterprise into groupedData
                groupedData = {
                    ...groupedData,
                    ...enterpriseGrouped, // adds Enterprise: []
                };
            }

            setDataVal(groupedData);
        }
    }, [
        activeTopicListData,
        chatterListDate,
        jobList
    ]);

    const handleClose = ( ) => {
        dispatch(setEditEmpty())
        setShowAddAlert(false)
    }

    
    return (
        <MainWrapper showPopup={showAddAlert}>
            <FlexContainer>
                <AlertConfigFont heading={(personalDetailsData?.is_custom == 'custom' && personalDetailsData?.heading_accent) ? personalDetailsData?.heading_accent :'#000000'}>
                    <div className='title'>Alert Configuration</div>
                    <div className='desc'>Configure notification thresholds for metric spikes</div>
                </AlertConfigFont>
                <AddTenantBtn 
                is_custom={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)'}
                onClick={() => setShowAddAlert(true)}>Add New Alert {AddIconWhite}</AddTenantBtn>
            </FlexContainer>
            <GridContainer>
                <div><AlertCountChart personalDetailsData={personalDetailsData} /> </div>
                <div><AlertTrendsChart personalDetailsData={personalDetailsData} /></div>
                {/* <div><UserAlertLoadChart data={alertsList} /></div> */}
            </GridContainer>
            <div>
                <AlertsTable data={alertsList} setShowAddAlert={setShowAddAlert} allTopics={[...(activeTopicListData || []), ...(chatterListDate || [])]} />
            </div>
            {
                showAddAlert &&
                <PopUp onClose={() => handleClose()}>
                    <AlertConfigure
                        selectedTabs={selectedTabs}
                        setSelectedTabs={setSelectedTabs}
                        channelData={channelData}
                        setChannelData={setChannelData}
                        dataVal={dataVal}
                        setDataVal={setDataVal}
                        setShowAddAlert={setShowAddAlert}
                        handleClose={handleClose}
                    />
                </PopUp>
            }

        </MainWrapper>
    );
};


export default AlertHomePage;